(function() {
  if (window.CustomCartUpsellsInit) return;
  window.CustomCartUpsellsInit = true;

  var discountCache = window.CustomCartUpsellsDiscountCache || {};
  window.CustomCartUpsellsDiscountCache = discountCache;

  /* ========= helpers ========= */

  function getUpsellsRoot() {
    return document.querySelector('[data-cart-upsells-root]');
  }

  function formatMoney(amount, moneyFormat) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try {
        var out = Shopify.formatMoney(amount, moneyFormat);
        if (out && !/^[0-9\s.,]+$/.test(String(out).trim())) return out;
      } catch (e) {}
    }

    if (typeof moneyFormat === 'string' && moneyFormat.indexOf('{{amount}}') !== -1) {
      var num = (amount / 100).toFixed(2);
      var out2 = moneyFormat.replace('{{amount}}', num);
      if (out2 && !/^[0-9\s.,]+$/.test(String(out2).trim())) return out2;
    }

    var root = getUpsellsRoot();
    var currency =
      (root && (root.getAttribute('data-upsells-currency') || (root.dataset && root.dataset.upsellsCurrency))) ||
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.currency) ||
      '';

    function minorUnit(code) {
      try {
        var d = new Intl.NumberFormat('en', { style: 'currency', currency: code })
          .resolvedOptions().maximumFractionDigits;
        return Math.pow(10, d);
      } catch (e) {
        return 100;
      }
    }

    function intlPrefix(minor, code) {
      if (!code) return (minor / 100).toFixed(2);

      var unit = minorUnit(code);
      var value = (minor || 0) / unit;

      try {
        var nf = new Intl.NumberFormat(undefined, { style: 'currency', currency: code });

        if (typeof nf.formatToParts === 'function') {
          var parts = nf.formatToParts(value);
          var sym = '';
          var numParts = [];

          for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            if (p.type === 'currency') sym = p.value;

            if (
              p.type === 'integer' ||
              p.type === 'group' ||
              p.type === 'decimal' ||
              p.type === 'fraction' ||
              p.type === 'minusSign' ||
              p.type === 'plusSign'
            ) {
              numParts.push(p.value);
            }
          }

          var numStr = numParts.join('');
          if (sym) return sym + numStr;
        }

        return nf.format(value);
      } catch (e) {
        return (minor / 100).toFixed(2) + (code ? (' ' + code) : '');
      }
    }

    return intlPrefix(amount, currency) || (amount / 100).toFixed(2);
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function() { return { items: [] }; });
  }

  function cartSignature(cart) {
    if (!cart || !cart.items) return '';
    var ids = cart.items.map(function(i) {
      return i.product_id + 'x' + i.quantity;
    }).join('|');
    return cart.item_count + '::' + ids;
  }

  function getRecommendationsUrl(productId, intent, limit) {
    var root = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      root = window.Shopify.routes.root;
    }
    var base = root.replace(/\/?$/, '/');
    return (
      base +
      'recommendations/products.json?product_id=' +
      encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=' + encodeURIComponent(limit * 3)
    );
  }

  function fetchRecommendationsForProduct(productId, intent, limit) {
    var url = getRecommendationsUrl(productId, intent, limit);

    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function() { return { products: [] }; });
  }

  function getDiscountSettings(root) {
    return {
      discountEnabled: !!(root && root.getAttribute('data-upsells-collection-discount-enabled') === 'true'),
      useProductCompareAt: !!(root && root.getAttribute('data-upsells-use-product-compare-at') === 'true')
    };
  }

  function getDisplayState(rawPrice, rawCompareAt, discountPercent, useProductCompareAt) {
    rawPrice = parseInt(rawPrice || '0', 10) || 0;
    rawCompareAt = parseInt(rawCompareAt || '0', 10) || 0;

    var hasCompareAtSale = rawCompareAt > rawPrice && rawCompareAt > 0;

    if (useProductCompareAt && hasCompareAtSale) {
      return {
        price: rawPrice,
        compareAt: rawCompareAt,
        onSale: true
      };
    }

    if (discountPercent > 0 && discountPercent < 100 && rawPrice > 0) {
      return {
        price: Math.round(rawPrice * (100 - discountPercent) / 100),
        compareAt: rawPrice,
        onSale: true
      };
    }

    if (hasCompareAtSale) {
      return {
        price: rawPrice,
        compareAt: rawCompareAt,
        onSale: true
      };
    }

    return {
      price: rawPrice,
      compareAt: 0,
      onSale: false
    };
  }

  function buildPriceHtmlFromState(state, moneyFormat) {
    if (state.onSale && state.compareAt > state.price) {
      return (
        '<span class="cart-upsells__price-old">' + formatMoney(state.compareAt, moneyFormat) + '</span>' +
        '<span class="cart-upsells__price-new">' + formatMoney(state.price, moneyFormat) + '</span>'
      );
    }

    return (
      '<span class="cart-upsells__price-regular">' + formatMoney(state.price, moneyFormat) + '</span>'
    );
  }

  function parseDiscountPercentFromProductHtml(html) {
    try {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var priceBlock = doc.querySelector('[data-pdp-collection-discount]');

      if (!priceBlock) return 0;

      var enabled = priceBlock.getAttribute('data-collection-discount-enabled') === 'true';
      if (!enabled) return 0;

      var percent = parseInt(priceBlock.getAttribute('data-collection-discount-percent') || '0', 10) || 0;
      if (percent > 0 && percent < 100) return percent;

      return 0;
    } catch (e) {
      return 0;
    }
  }

  function fetchDiscountPercentForProduct(productUrl) {
    if (!productUrl) return Promise.resolve(0);

    if (typeof discountCache[productUrl] === 'number') {
      return Promise.resolve(discountCache[productUrl]);
    }

    if (discountCache[productUrl] && typeof discountCache[productUrl].then === 'function') {
      return discountCache[productUrl];
    }

    discountCache[productUrl] = fetch(productUrl, {
      credentials: 'same-origin',
      cache: 'force-cache'
    })
      .then(function(r) {
        return r.ok ? r.text() : '';
      })
      .then(function(html) {
        var percent = parseDiscountPercentFromProductHtml(html);
        discountCache[productUrl] = percent;
        return percent;
      })
      .catch(function() {
        discountCache[productUrl] = 0;
        return 0;
      });

    return discountCache[productUrl];
  }

  function getSelectedVariantPriceData(card) {
    if (!card) {
      return { price: 0, compareAt: 0 };
    }

    var select = card.querySelector('[data-upsell-variant-select]');
    if (select && select.options && select.options[select.selectedIndex]) {
      var opt = select.options[select.selectedIndex];
      return {
        price: parseInt(opt.getAttribute('data-price') || '0', 10) || 0,
        compareAt: parseInt(opt.getAttribute('data-compare-at') || '0', 10) || 0
      };
    }

    return {
      price: parseInt(card.getAttribute('data-upsell-default-price') || '0', 10) || 0,
      compareAt: parseInt(card.getAttribute('data-upsell-default-compare-at') || '0', 10) || 0
    };
  }

  function refreshUpsellCardPrice(card) {
    if (!card) return;

    var root = card.closest('[data-cart-upsells-root]');
    if (!root) return;

    var moneyFormat =
      root.getAttribute('data-upsells-money-format') ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    var settings = getDiscountSettings(root);
    var discountPercent = settings.discountEnabled
      ? (parseInt(card.getAttribute('data-upsell-discount-percent') || '0', 10) || 0)
      : 0;

    var data = getSelectedVariantPriceData(card);
    var state = getDisplayState(
      data.price,
      data.compareAt,
      discountPercent,
      settings.useProductCompareAt
    );

    var priceWrap = card.querySelector('.cart-upsells__price');
    if (!priceWrap) return;

    priceWrap.innerHTML = buildPriceHtmlFromState(state, moneyFormat);
  }

  function hydrateUpsellDiscounts(listEl) {
    if (!listEl) return;

    var root = listEl.closest('[data-cart-upsells-root]');
    if (!root) return;

    var settings = getDiscountSettings(root);
    var cards = listEl.querySelectorAll('.cart-upsells__item[data-upsell-product-url]');

    cards.forEach(function(card) {
      refreshUpsellCardPrice(card);

      if (!settings.discountEnabled) return;

      var productUrl = card.getAttribute('data-upsell-product-url') || '';
      if (!productUrl) return;

      fetchDiscountPercentForProduct(productUrl).then(function(percent) {
        if (!card.isConnected) return;
        card.setAttribute('data-upsell-discount-percent', String(percent || 0));
        refreshUpsellCardPrice(card);
      });
    });
  }

  function updateUpsellPriceFromSelect(selectEl) {
    if (!selectEl) return;
    var card = selectEl.closest('.cart-upsells__item');
    if (!card) return;
    refreshUpsellCardPrice(card);
  }

  /* ========= upsell cards ========= */

  function buildCardsHtml(products, inCartProductIds, moneyFormat, limit, discountEnabled, useProductCompareAt) {
    var usedIds = new Set();
    var picked = [];

    products.forEach(function(p) {
      if (!p || p.available === false) return;
      if (inCartProductIds.indexOf(p.id) !== -1) return;
      if (usedIds.has(p.id)) return;
      if (picked.length >= limit) return;

      usedIds.add(p.id);
      picked.push(p);
    });

    if (!picked.length) return '';

    return picked.map(function(p) {
      var img = p.featured_image || (p.images && p.images[0]);
      var imgUrl = null;

      if (img && typeof img === 'string') {
        imgUrl = img.replace(/_(\d+x\d+|x\d+)\./, '_160x.');
      } else if (img && img.src) {
        imgUrl = img.src;
      }

      var title = p.title || '';
      var words = title.split(' ').filter(function(w){ return w.length; });
      var shortWords = words.slice(0, 5);
      var shortTitle = shortWords.join(' ');
      if (words.length > 5) {
        shortTitle += '…';
      }

      var variants = p.variants || [];
      var fav = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) {
          fav = variants[i];
          break;
        }
      }
      if (!fav && variants.length) fav = variants[0] || null;

      var selectedVariant = fav || null;
      var basePrice = selectedVariant && selectedVariant.price != null ? selectedVariant.price : p.price;
      var baseCompareAt = selectedVariant && selectedVariant.compare_at_price != null
        ? selectedVariant.compare_at_price
        : p.compare_at_price;

      var initialDiscountPercent = discountEnabled && typeof discountCache[p.url] === 'number'
        ? (discountCache[p.url] || 0)
        : 0;

      var initialState = getDisplayState(
        basePrice,
        baseCompareAt,
        initialDiscountPercent,
        useProductCompareAt
      );

      var priceHtml = buildPriceHtmlFromState(initialState, moneyFormat);

      var hasMultipleVariants = variants.length > 1;
      var selectedVariantId = selectedVariant && selectedVariant.id;
      var handle = p.handle || '';
      var productUrl = p.url || (handle ? ('/products/' + handle) : '#');

      var selectorHtml = '';
      if (hasMultipleVariants) {
        selectorHtml += '<select class="cart-upsells__variant-select" data-upsell-variant-select>';
        variants.forEach(function(v) {
          if (!v) return;
          var optLabel = v.public_title || v.title || '';
          selectorHtml +=
            '<option value="' + v.id + '"' +
              (selectedVariantId && String(v.id) === String(selectedVariantId) ? ' selected' : '') +
              ' data-price="' + (v.price || 0) + '"' +
              ' data-compare-at="' + (v.compare_at_price || 0) + '">' +
              optLabel +
            '</option>';
        });
        selectorHtml += '</select>';
      }

      var buttonHtml = '';
      if (!hasMultipleVariants && selectedVariant && selectedVariant.id) {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" ' +
            'data-cart-upsell-add data-variant-id="' + selectedVariant.id + '">' +
            '<span class="cart-upsells__add-icon">+</span>' +
          '</button>';
      } else {
        buttonHtml =
          '<button type="button" class="cart-upsells__add" data-cart-upsell-add>' +
            '<span class="cart-upsells__add-icon">+</span>' +
          '</button>';
      }

      return '' +
        '<div class="cart-upsells__item"' +
          ' data-upsell-product-url="' + productUrl + '"' +
          ' data-upsell-discount-percent="' + initialDiscountPercent + '"' +
          ' data-upsell-default-price="' + (basePrice || 0) + '"' +
          ' data-upsell-default-compare-at="' + (baseCompareAt || 0) + '">' +
          '<a href="' + productUrl + '" class="cart-upsells__media" data-instant>' +
            (imgUrl ? '<img src="' + imgUrl + '" alt="' + shortTitle.replace(/"/g, '&quot;') + '">' : '') +
          '</a>' +
          '<div class="cart-upsells__content">' +
            '<a href="' + productUrl + '" class="cart-upsells__title" data-instant>' +
              shortTitle +
            '</a>' +
            '<div class="cart-upsells__bottom-row">' +
              '<div class="cart-upsells__price">' + priceHtml + '</div>' +
              (selectorHtml || '') +
            '</div>' +
          '</div>' +
          buttonHtml +
        '</div>';
    }).join('');
  }

  /* ========= render upsells ========= */

  var lastSignature = null;
  var updating = false;

  function renderCartUpsells() {
    if (updating) return;
    updating = true;

    var root = getUpsellsRoot();
    if (!root) {
      updating = false;
      return;
    }

    var listEl = root.querySelector('[data-cart-upsells-list]');
    if (!listEl) {
      updating = false;
      return;
    }

    var intent = root.getAttribute('data-upsells-intent') || 'complementary';
    var limit = parseInt(root.getAttribute('data-upsells-limit') || '3', 10);
    var moneyFormat =
      root.getAttribute('data-upsells-money-format') ||
      (window.Shopify && window.Shopify.money_format) ||
      '${{amount}}';

    var settings = getDiscountSettings(root);

    fetchCart().then(function(cart) {
      var sig = cartSignature(cart);
      if (sig === lastSignature && listEl.children.length) {
        updating = false;
        hydrateUpsellDiscounts(listEl);
        return;
      }
      lastSignature = sig;

      if (!cart || !cart.items || !cart.items.length) {
        root.style.display = 'none';
        listEl.innerHTML = '';
        updating = false;
        return;
      }

      root.style.display = '';
      listEl.innerHTML = '';

      var inCartProductIds = cart.items.map(function(i){ return i.product_id; });
      var allRecs = [];
      var productIds = inCartProductIds.slice();
      var idx = 0;

      function step() {
        if (idx >= productIds.length || allRecs.length >= limit * 3) {
          var html = buildCardsHtml(
            allRecs,
            inCartProductIds,
            moneyFormat,
            limit,
            settings.discountEnabled,
            settings.useProductCompareAt
          );

          if (!html) {
            root.style.display = 'none';
            listEl.innerHTML = '';
          } else {
            root.style.display = '';
            listEl.innerHTML = html;

            var selects = listEl.querySelectorAll('[data-upsell-variant-select]');
            selects.forEach(function(sel) {
              updateUpsellPriceFromSelect(sel);
            });

            hydrateUpsellDiscounts(listEl);
          }

          updating = false;
          return;
        }

        var pid = productIds[idx++];
        fetchRecommendationsForProduct(pid, intent, limit).then(function(data) {
          if (data && Array.isArray(data.products)) {
            allRecs = allRecs.concat(data.products);
          }
          step();
        }).catch(function() {
          step();
        });
      }

      step();
    }).catch(function() {
      updating = false;
    });
  }

  /* ========= perерисовка самого cart-drawer из секции ========= */

  function getCartDrawerSectionIds() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return null;

    var node = drawer;
    while (node && node !== document.documentElement) {
      if (node.id && node.id.indexOf('shopify-section-') === 0) {
        return {
          domId: node.id,
          sectionId: node.id.replace('shopify-section-', '')
        };
      }
      node = node.parentElement;
    }
    return null;
  }

  function setupDrawerMutationObserver() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var itemsHolder = drawer.querySelector('[data-items-holder]');
    if (!itemsHolder) return;

    if (window.CustomCartUpsellsItemsObserver) {
      window.CustomCartUpsellsItemsObserver.disconnect();
    }

    var observer = new MutationObserver(function(muts) {
      var changed = muts.some(function(m){ return m.type === 'childList'; });
      if (changed) {
        renderCartUpsells();
      }
    });

    observer.observe(itemsHolder, { childList: true, subtree: true });
    window.CustomCartUpsellsItemsObserver = observer;
  }

  function refreshCartDrawerFromSection(detail) {
    var ids = getCartDrawerSectionIds();
    if (!ids) {
      renderCartUpsells();
      return Promise.resolve();
    }

    var sectionDomId = ids.domId;
    var sectionId = ids.sectionId;

    return fetch('/?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(json){
        if (!json || !json[sectionId]) {
          renderCartUpsells();
          return;
        }

        var html = json[sectionId];
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var freshSection = tmp.querySelector('#' + sectionDomId) || tmp.firstElementChild;
        if (!freshSection) {
          renderCartUpsells();
          return;
        }

        var freshDrawer = freshSection.querySelector('#cart-drawer');
        if (!freshDrawer) {
          renderCartUpsells();
          return;
        }

        var tpl = freshDrawer.querySelector('[data-cart-drawer-template]');
        var newInner;
        if (tpl) {
          newInner = tpl.innerHTML;
        } else {
          newInner = freshDrawer.innerHTML;
        }

        var liveDrawer = document.getElementById('cart-drawer');
        if (!liveDrawer) {
          renderCartUpsells();
          return;
        }

        liveDrawer.innerHTML = newInner;

        setupDrawerMutationObserver();

        var root = document.documentElement || document;
        ['cart:updated','cart:refresh','ajaxProduct:added','product:added'].forEach(function(name){
          try {
            root.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || null }));
          } catch (e) {}
        });

        renderCartUpsells();
      })
      .catch(function() {
        renderCartUpsells();
      });
  }

  /* ========= клики по кнопкам в апсейлах ========= */

  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;

    var variantId = button.getAttribute('data-variant-id');

    if (!variantId) {
      var card = button.closest('.cart-upsells__item');
      if (card) {
        var select = card.querySelector('[data-upsell-variant-select]');
        if (select) {
          variantId = select.value;
        }
      }
    }

    if (!variantId) return;

    event.preventDefault();
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
      credentials: 'same-origin'
    })
      .then(function(r){ return r.json(); })
      .then(function(data) {
        button.disabled = false;
        return refreshCartDrawerFromSection(data);
      })
      .catch(function() {
        button.disabled = false;
      });
  });

  document.addEventListener('change', function(event) {
    var select = event.target.closest('[data-upsell-variant-select]');
    if (!select) return;
    updateUpsellPriceFromSelect(select);
  });

  /* ========= триггеры рендера апсейлов ========= */

  ['cart-drawer:open', 'cart:updated', 'cart:refresh', 'ajaxProduct:added', 'cart:change']
    .forEach(function(evt) {
      document.addEventListener(evt, function() {
        renderCartUpsells();
      });
    });

  var mo = new MutationObserver(function(muts) {
    muts.forEach(function(m) {
      (m.addedNodes || []).forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-cart-upsells-root]')) {
          setupDrawerMutationObserver();
          renderCartUpsells();
        } else if (node.querySelector && node.querySelector('[data-cart-upsells-root]')) {
          setupDrawerMutationObserver();
          renderCartUpsells();
        }
      });
    });
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupDrawerMutationObserver();
      renderCartUpsells();
    });
  } else {
    setupDrawerMutationObserver();
    renderCartUpsells();
  }
})();